<template>
  <!-- 公共弹窗 -->
  <div class="publicDialog">
    <div class="dialog">
      <div class="title">
        {{dialogInfo.title}}
      </div>
      <div class="info" v-html="dialogInfo.info">
        <!-- {{info}} -->
      </div>
      <div class="btns">
        <div class="btn btn1" v-if="dialogInfo.btn1" @click="handleBtn1">{{dialogInfo.btn1}}</div>
        <div class="btn btn2" v-if="dialogInfo.btn2" @click="handleBtn2">{{dialogInfo.btn2}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dialogInfo','dialogIsShow', 'token'],
  name: '',
  data () {
    return {
      isShow:this.dialogIsShow,
    };
  },
  watch: {
    isShow (val) {
      this.dialogIsShow = val;
    }
  },
  computed: {
  },
  created () { },
  methods: {
    // // 展示提示弹窗
    // showDialog (visible) {
    //   this.dialogIsShow = visible
    // },
    // 关闭
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('changeDialogShow', false);
    },
    // 第一个按钮的点击
    handleBtn1(){
      console.log('按钮点击');
      this.doClose()
    },
    // 第二个按钮的点击
    handleBtn2(){
      console.log('按钮点击');
      this.doClose()
    }
  }
}
</script>

<style lang='less' scoped>
.publicDialog {
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  .dialog {
    width: 6.2rem;
    height: 3.86rem;
    background: #ffffff;
    border-radius: 0.2rem;
    padding: 0.4rem 0.56rem;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      font-size: 0.4rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 0.56rem;
    }
    .info {
      margin: 0.4rem 0;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.4rem;
      text-align: center;
    }
    .btns {
      display: flex;
      .btn {
        width: 3rem;
        height: 0.9rem;
        background: linear-gradient(
          131deg,
          #ffe7ce 0%,
          #ecccac 68%,
          #e8b37f 100%
        );
        border-radius: 0.45rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.28rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #984b26;
      }
    }
  }
}
</style>
